import { Button } from '@/components/ui/button'
import { IconButton } from '@/components/ui/icon-button'
import { Expand, Image, Mic, SendIcon } from 'lucide-solid'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Flex } from 'styled-system/jsx'
import { useUi, useUpsert } from '../state'
import './input.css'
import { useAuth } from '@state/auth'
import { Show } from 'solid-js'

const Toolbar = (props: { onSend: () => void }) => {
  const { sendIsLoading } = useService(useUpsert)()
  const { canSendAudio } = useService(useAuth)()

  return (
    <Flex
      w="100%"
      justifyContent="space-between"
    >
      <div id="custom-toolbar">
        <select class="ql-header">
          <option selected />
          <option value="1">Heading</option>
          {/* <option value="2">Heading 2</option> */}
        </select>
        <button
          type="button"
          class="ql-bold"
        />
        <button
          type="button"
          class="ql-list"
          value="bullet"
        />
        <button
          type="button"
          class="ql-image"
        >
        </button>
        <Show when={canSendAudio()}>
          <button
            type="button"
            class="ql-undo"
          >
            <Mic size={14} />
          </button>
        </Show>
      </div>

      <Flex gap={2}>
        <Button
          onClick={props.onSend}
          loading={sendIsLoading()}
          type="submit"
          variant="solid"
          aria-label="Send message"
          style={{ background: 'var(--colors-editorial-accent)', color: 'var(--colors-editorial-badge-fg)', border: 'none' }}
          class={css({
            w: '38px',
            h: '38px',
            minW: '0',
            p: '0',
            borderRadius: '11px',
            '& svg': { width: '17px', height: '17px' },
            _hover: { background: 'var(--colors-editorial-accent-deep)' },
          })}
        >
          <SendIcon />
        </Button>
      </Flex>
    </Flex>
  )
}

export default Toolbar
